import { BKJIcon } from '@awais4123/fillify-design-library';
import { BKJIconNameType } from '@awais4123/fillify-design-library/lib/components/BKJIcon/BKJIcon.types';
import { IconButtonWrapper } from './IconButton.styled';

export function IconButton({
  iconName,
  onClick,
}: {
  iconName: BKJIconNameType;
  onClick: (ev: unknown) => void;
}) {
  return (
    <IconButtonWrapper onClick={onClick}>
      <BKJIcon iconName={iconName} />
    </IconButtonWrapper>
  );
}
